import script from "./BlockDropsBenefits.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockDropsBenefits.vue?vue&type=script&setup=true&lang=js"

import "./BlockDropsBenefits.vue?vue&type=style&index=0&id=06d65f28&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d65f28"]])

export default __exports__